import { ITileset, TilesetProcessingStatus } from '~/client/graph'

/**
 * Gate positively on `success` rather than excluding in-flight states:
 * queued/processing, failed, superseded (an old replaced version that still
 * carries mapboxData) and a missing status are all NOT ready.
 *
 * Neither of the two signals that look like substitutes is one. `isProcessed`
 * only means the backend stopped polling — it is set alongside a `failed`
 * status too. And `mapboxData` is never persisted: GetMapboxTilesets fills it
 * in for EVERY tileset of the project from the Mapbox account listing,
 * regardless of status, so `activeTilesetsList` / `activeTilesetsById` still
 * carry non-ready tilesets after a page load.
 *
 * Accepts `undefined` so it subsumes the presence check callers previously did
 * against those two selectors.
 */
export function isTilesetReady(
  tileset: ITileset | undefined,
): tileset is ITileset {
  return tileset?.status === TilesetProcessingStatus.Success
}
